var PluginManager = {
	plugins:[],
	
	add: function(o) {
		PluginManager.plugins.push(o);
		if (o.register) o.register();
	},
	
	on: function(event, params) {
		var no;
		for(no in PluginManager.plugins) {
			if (PluginManager.plugins[no].hasOwnProperty(event)) {
				PluginManager.plugins[no][event](params);
			}
		}
	},
	
	onInit: function() {
		var no;
		for(no in PluginManager.plugins) {
			PluginManager.plugins[no].init();
		}

		for(no in PluginManager.plugins) {
			if (PluginManager.plugins[no].afterInit != undefined) PluginManager.plugins[no].afterInit();
		}
	}
}